import React, { lazy } from 'react';
import { Check } from 'lucide-react';
const testimonials = [{
  label: 'Remodelación de Cocina · Conucos, Bucaramanga',
  projectImage: 'https://cdn.magicpatterns.com/uploads/feMNNq29tCnS2zP7rS3DYJ/GERFAJ_-_CONUCOS_-_TESTI..png',
  additionalImage: 'https://cdn.magicpatterns.com/uploads/4ANTpb8K9SpqGqoFLgAx2f/GERFJA_-_CONUCOS.png',
  chatImage: 'https://cdn.magicpatterns.com/uploads/feMNNq29tCnS2zP7rS3DYJ/GERFAJ_-_CONUCOS_-_TESTI..png',
  contactName: 'Ivonne - Remodelación Conucos',
  messages: [{
    text: '¡Hola! No les había escrito porque estábamos terminando de acomodar todo, pero hoy que entré a la cocina me acordé de decirles: ¡quedó hermosa! El cambio en el apartamento fue total.',
    time: '03:46 PM',
    sent: false
  }, {
    text: 'De verdad gracias por cumplirnos con los tiempos, me preocupaba mucho que la obra se alargara pero todo fluyó súper bien. Los acabados quedaron impecables, mi familia está encantada.',
    time: '03:47 PM',
    sent: false
  }, {
    text: '¡Qué felicidad, Ivonne! Ese era el objetivo, que sintieran que estrenaban hogar sin complicaciones. Disfruta mucho tu cocina nueva, ¡quedó increíble! 😊👌',
    time: '03:48 PM',
    sent: true
  }]
}, {
  label: 'Obra Civil · San Roque, Cesar',
  projectImage: 'https://cdn.magicpatterns.com/uploads/ajYUKR9AK2iQvZwDeWfMZ8/GERFAJ_-_SAN_ROQUE_-_TESTI.png',
  additionalImage: 'https://cdn.magicpatterns.com/uploads/dZ1N3EDBnjvRQ9jxCtN3mX/GERFAJ_-_SAN_ROQUE.png',
  chatImage: 'https://cdn.magicpatterns.com/uploads/ajYUKR9AK2iQvZwDeWfMZ8/GERFAJ_-_SAN_ROQUE_-_TESTI.png',
  contactName: 'Cliente San Roque - Cesar',
  messages: [{
    text: 'Hola Arqui, paso por aquí para agradecerles por el resultado.',
    time: '7:42 PM',
    sent: false
  }, {
    text: 'La verdad, ver el patio y la iluminación así de noche es otra cosa.',
    time: '7:42 PM',
    sent: false
  }, {
    text: 'El equipo siempre estuvo pendiente de cada detalle y los tiempos se cumplieron.',
    time: '7:43 PM',
    sent: false
  }, {
    text: 'Gracias arqui, de verdad, todo impecable',
    time: '7:43 PM',
    sent: false
  }, {
    text: '¡Qué alegría leer eso! Disfruten mucho ese nuevo espacio. 🏡🏠',
    time: '7:44 PM',
    sent: true
  }]
}, {
  label: 'Proyecto Institucional · Especial',
  projectImage: 'https://cdn.magicpatterns.com/uploads/dtdvumpmQ4cFLwRiTR4kMT/GERFAJ_-_AUDITORIO_-_TESTI.png',
  additionalImage: 'https://cdn.magicpatterns.com/uploads/vJGyiTSifgxHiq5GzeBtXV/GERFAJ_-_AUDITORIO.png',
  chatImage: 'https://cdn.magicpatterns.com/uploads/dtdvumpmQ4cFLwRiTR4kMT/GERFAJ_-_AUDITORIO_-_TESTI.png',
  contactName: 'Cliente Auditorio',
  messages: [{
    text: 'Arquitectos, buenos días. Queríamos agradecerles formalmente por la entrega del auditorio. El acabado del techo y la iluminación quedaron espectaculares, justo la imagen institucional que buscábamos.',
    time: '09:12 AM',
    sent: false
  }, {
    text: 'Varios miembros de la junta comentaron lo bien que se aprovechó el espacio y la calidad de los materiales. Gracias por la paciencia con los detalles finales, valió totalmente la pena.',
    time: '09:14 AM',
    sent: false
  }, {
    text: 'Es un gusto para nosotros, la verdad es que el diseño de luces y el cielo raso le dieron un toque muy profesional. ¡Gracias por confiar en nosotros para este gran proyecto! 🤝✨',
    time: '09:15 AM',
    sent: true
  }]
}];
export function TestimonialsSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    offerSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#1A1A1A] py-12 md:py-20" style={{
    contentVisibility: 'auto',
    contain: 'layout style paint'
  }} data-id="element-367">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-368">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12" data-id="element-369">
          <h2 className="text-[26px] md:text-[40px] font-bold text-white mb-3 md:mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-370">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-[15px] md:text-[17px] text-[#A0A0A0] font-normal max-w-2xl mx-auto mb-4" style={{
          lineHeight: '1.6'
        }} data-id="element-371">
            Historias reales de obras entregadas a tiempo y con transparencia.
          </p>
          <div className="w-16 h-1 bg-[#E8621A] mx-auto rounded-full" data-id="element-372"></div>
        </div>

        {/* Testimonial Blocks */}
        <div className="space-y-8 md:space-y-16" data-id="element-373">
          {testimonials.map((testimonial, index) => <div key={index} className="max-w-4xl mx-auto" data-id="element-374">
              {/* CTA Button - Show before 2nd and 3rd testimonials, full width on mobile */}
              {index > 0 && <div className="text-center mb-6 md:mb-8" data-id="element-375">
                  <button onClick={scrollToOffer} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 md:py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-xl hover:scale-105 min-h-[52px]" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-376">
                    Quiero asesorarme
                  </button>
                </div>}

              {/* Label Tag */}
              <div className="mb-4 border-l-4 border-[#E8621A] pl-3" data-id="element-377">
                <span className="inline-block bg-[#2A2A2A] text-[#E8621A] px-4 py-2 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-378">
                  {testimonial.label}
                </span>
              </div>

              {/* Additional Project Photo - Space photos first */}
              <div className="relative rounded-xl overflow-hidden shadow-[0_8px_32px_rgba(232,98,26,0.15)] mb-6" data-id="element-379">
                <img src={testimonial.additionalImage} alt={`${testimonial.label} - Vista del espacio`} className="w-full h-auto object-cover" width="1200" height="800" loading="lazy" decoding="async" data-id="element-380" />
              </div>

              {/* Chat Screenshot Photo - Chat image second */}
              <div className="relative rounded-xl overflow-hidden shadow-[0_8px_32px_rgba(232,98,26,0.15)]" data-id="element-381">
                <img src={testimonial.projectImage} alt={`${testimonial.label} - Testimonio`} className="w-full h-auto object-cover" width="1200" height="800" loading="lazy" decoding="async" data-id="element-382" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}